import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpErrorInterceptor } from './http.interceptor';

@Injectable({
  providedIn: 'root',
})
export class HttpErrorInterceptorService {
  private httpErrorInterceptor?: HttpErrorInterceptor;
  private httpInterceptor = inject(HTTP_INTERCEPTORS);

  constructor() {
    this.httpErrorInterceptor = this.httpInterceptor.find(
      (interceptor) => interceptor instanceof HttpErrorInterceptor,
    ) as HttpErrorInterceptor;
  }

  public addIgnoreHttpStatusForUrlBeginningBy(
    status: number,
    method: string,
    prefixUrl: string,
  ): void {
    if (this.httpErrorInterceptor === undefined) {
      console.warn('HttpErrorInterceptor is not defined');
      return;
    }
    this.httpErrorInterceptor?.addIgnoreHttpStatusForUrlBeginningBy(status, method, prefixUrl);
  }
}
